/* eslint-disable quotes */
import { log as pilog } from "@limitless/common/utils";
export const isAnnouncementCriteriaMet = announcement => {
  const log = pilog.getLogger("AnnouncementUtil isAnnouncementCriteriaMet");
  const {
    targetPlatformType,
    targetVersion
  } = announcement;
  const appType = process.env.REACT_APP_TYPE ? process.env.REACT_APP_TYPE : "web";
  log.debug(`${appType} App Type, target ${targetPlatformType}`);
  if (targetPlatformType && targetPlatformType !== appType) {
    return false;
  }
  if (targetVersion && targetVersion !== process.env.REACT_APP_VERSION) {
    return false;
  }
  return true;
};

/**
 * Validates the template content of the announcement
 *
 * Here mostly for historic reasons, and some none conformant templates hiding in S3!
 *
 * @param {object} announcement
 */
export const validateTemplateContent = announcement => {
  const log = pilog.getLogger("AnnouncementUtil validateTemplateContent");
  try {
    const template = JSON.parse(announcement.template);
    return template;
  } catch (error) {
    log.warn(`Unable to parse announcement ${announcement.announcementId}`);

    //attempt to strip out new lines
    try {
      //eslint-disable-next-line
      let template = announcement.template.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, " ");
      template = JSON.parse(template);
      log.debug("new line removal successful");
      return template;
    } catch (error) {
      log.debug("Template not valid after new line removal");
    }

    //this was added specifically for the You Smashed It announcement
    //for some reason on occasion, the escaped HTML was not escapaed.
    try {
      let template = announcement.template.replace(new RegExp('class="img-responsive"', "g"), 'class=\\"img-responsive\\"');
      template = template.replace(new RegExp('="', "g"), '=\\"');
      template = template.replace(new RegExp('}">', "g"), '}\\">');
      template = template.replace(new RegExp(';">', "g"), ';\\">');
      template = JSON.parse(template);
      //if this is not valid JSON it the below will crash
      const a = template.component[1];
      log.debug(a);
      return template;
    } catch (error) {
      log.warn(`Announcement ${announcement.announcementId} parsing fallback failed!`, error);
      //fallback to Markdown

      return null;
    }
  }
};